// Phase 10 — Reading List module copy strings.

export const reading = {
  pageTitle: 'Reading',
  pageSubtitle: 'Books and articles to read.',
  emptyTitle: 'Nothing on your list',
  emptyBody: 'Add a book or article to start your reading list.',
  loadingLabel: 'Loading reading list…',
  errorTitle: 'Could not load reading list',
  errorBody: 'Check your connection and try again.',
  retry: 'Retry',
  addLabel: 'Add item',
  editLabel: 'Edit item',
  saveLabel: 'Save',
  deleteLabel: 'Delete',
  titleLabel: 'Title',
  authorLabel: 'Author',
  statusLabel: 'Status',
  ratingLabel: 'Rating',
  notesLabel: 'Notes',
  statusToRead: 'To read',
  statusReading: 'Reading',
  statusDone: 'Done',
  deletedToast: 'Item removed.',
  createdToast: 'Item saved.',
  updatedToast: 'Item updated.',
  dashboardTitle: 'Reading',
  dashboardInProgress: (count: number) => `${count} in progress`,
  dashboardEmpty: 'No books in progress',
} as const;
